import { render, staticRenderFns } from "./NoAccessPage.vue?vue&type=template&id=47948b42&"
import script from "./NoAccessPage.vue?vue&type=script&lang=js&"
export * from "./NoAccessPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports